export { default } from './price';
